// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import IntegerValue from '../common/IntegerValue';
import { InfoTooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import DisclaimerInfos from '@/types/disclaimer-infos';
import ArrowIcon from '../common/ArrowIcon';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  value?: {
    upside: number;
    downside: number;
  };
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
  decimalPlace?: number;
};

const UpDownCell: React.FunctionComponent<Props> = ({
  value,
  className,
  item,
  disclaimer,
  onClick,
  id,
  valueDisclaimer,
  hasDisclaimer,
  locale,
  decimalPlace = 1,
}: Props) => {
  if (value == null || (value.downside == null && value.upside == null)) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  return (
    <div className={classNames(className, 'cell up-down-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        {value.upside != null && (
          <span className="up">
            <ArrowIcon type="up" title={formatMessage('Common.Upside')} useHTMLEntity margin="0 4px 0 0" />
            <IntegerValue value={value.upside} isPercentage decimalPlace={decimalPlace} locale={locale} />
          </span>
        )}
        {value.downside != null && (
          <span className="down">
            <ArrowIcon type="down" title={formatMessage('Common.Downside')} useHTMLEntity margin="0 4px 0 0" />
            <IntegerValue value={value.downside} isPercentage decimalPlace={decimalPlace} locale={locale} />
          </span>
        )}

        {hasDisclaimer && '*'}

        {valueDisclaimer && <InfoTooltip title={valueDisclaimer.title} message={valueDisclaimer.message} list={valueDisclaimer.list} />}
      </span>
    </div>
  );
};

export default UpDownCell;
